<mpro-dropdown
  [disabled]="disabled"
  [title]="title"
  [inputValue]="inputValues.join(', ')"
  [placeholder]="options[0][nameProperty]"
  [horizontal]="horizontal"
>
  <mpro-dropdown-item
    *ngFor="let o of options"
    [leftText]="o[nameProperty]"
    [disabled]="o.disabled"
    [selected]="isValueSelected(o[nameProperty])"
    [showLock]="!!o.authDisabled"
    (itemClicked)="onSelect(o)"
  ></mpro-dropdown-item>
</mpro-dropdown>
